import store from '../../store';
import AuthenticationService from './authentication/authentication-service';
import MappingService from './mapping/mapping-service';
import ProjectService from './organisation/project-service';
import ReportService from './report/report-service';
import RouterService from './navigation/router-service';
import TagService from './taxonomy/tag-service';
import TeamService from './organisation/team-service';
import UserService from './organisation/user-service';
export default class ServiceContainer {
    /**
     * Constructor
     */
    constructor() {
        this.store = store;
    }
    /**
     * Returns the authentication service
     */
    get authenticationService() {
        if (!this._authenticationService) {
            this._authenticationService = new AuthenticationService(this.store);
        }
        return this._authenticationService;
    }
    /**
     * Returns the mapping service
     */
    get mappingService() {
        if (!this._mappingService) {
            this._mappingService = new MappingService(this.store, this.authenticationService);
        }
        return this._mappingService;
    }
    /**
     * Returns the project service
     */
    get projectService() {
        if (!this._projectService) {
            this._projectService = new ProjectService(this.store, this.authenticationService);
        }
        return this._projectService;
    }
    /**
     * Returns the report service
     */
    get reportService() {
        if (!this._reportService) {
            this._reportService = new ReportService(this.store, this.authenticationService);
        }
        return this._reportService;
    }
    /**
     * Returns the router service
     */
    get routerService() {
        if (!this._routerService) {
            this._routerService = new RouterService(this.store);
        }
        return this._routerService;
    }
    /**
     * Returns the tag service
     */
    get tagService() {
        if (!this._tagService) {
            this._tagService = new TagService(this.store, this.authenticationService);
        }
        return this._tagService;
    }
    /**
     * Returns the team service
     */
    get teamService() {
        if (!this._teamService) {
            this._teamService = new TeamService(this.store, this.authenticationService);
        }
        return this._teamService;
    }
    /**
     * Returns the user service
     */
    get userService() {
        if (!this._userService) {
            this._userService = new UserService(this.store, this.authenticationService);
        }
        return this._userService;
    }
}
//# sourceMappingURL=service-container.js.map